import React from 'react';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isString as _isString } from 'lodash';
import PropTypes from 'prop-types';

import { VFButton, VFText, QuickActionMenu } from '@vfgroup-oneplatform/foundation/Components';
import {
  useTheme,
  LightThemeColors,
  DarkThemeColors,
  Types,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../FrameworkTestKeys';

import styles from './Logout.Styles';

const Logout = ({
  isVisible,
  toggleModal,
  logout,
  closeModal,
  modalType,
  titleStyle,
  btnSuccessStyle,
  btnSuccessTextStyle,
  btnRejectStyle,
  btnRejectTextStyle,
  ...props
}) => {
  const theme = useTheme() || LightThemeColors;
  const customGradientBackgroundColors =
    !_isString(modalType) && theme.name === DarkThemeColors.name
      ? DarkThemeColors.colors.quickActionGradientColors.primary.slice(1, 3)
      : undefined;

  return (
    <QuickActionMenu
      title="logout_title"
      isVisible={isVisible}
      toggleModal={toggleModal}
      closeModal={closeModal}
      customGradientBackgroundColors={customGradientBackgroundColors}
      testID={FrameworkTestKeys.LogOutQA}
      type={modalType}
      headerStyle={styles.headerStyle}
    >
      <VFText style={[styles.title, titleStyle]} i18nKey="logout_description" />
      <VFButton
        title="logout_button"
        type="secondary"
        style={[styles.btnSuccess(theme), btnSuccessStyle]}
        textStyle={[styles.btnSuccessText(theme), btnSuccessTextStyle]}
        onPress={logout}
        testID={FrameworkTestKeys.LogOutQALogOutBtn}
      />
      <VFButton
        title="logout_cancel_button"
        type="primary"
        style={[styles.btnReject, btnRejectStyle]}
        textStyle={[styles.btnRejectText(theme), btnRejectTextStyle]}
        onPress={toggleModal}
        testID={FrameworkTestKeys.LogOutQACancelBtn}
      />
    </QuickActionMenu>
  );
};

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  modalType: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  titleStyle: TextPropTypes.style,
  btnSuccessStyle: ViewPropTypes.style,
  btnSuccessTextStyle: TextPropTypes.style,
  btnRejectStyle: ViewPropTypes.style,
  btnRejectTextStyle: TextPropTypes.style,
};

Logout.defaultProps = {
  logout: () => {},
  toggleModal: () => {},
  isVisible: true,
};

export default Logout;
